export enum SmsTemplateNames {
  smsLrpQuote = 'smsLrpQuote',
  smsCustom = 'smsCustom',
  smsOptInConfirmation = 'smsOptInConfirmation',
  smsOptOutConfirmation = 'smsOptOutConfirmation',
}
